// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Header":"Header-x8x7gn234gcvrnxbdn2crgum1zj8nukt8tc9vgzj66dtwku88my9e3ehawj3ss6yt4hr8tuqkk8mqarpwxu1y5jha3qd78qqk8393q","ButtonWrapper":"ButtonWrapper-4fpmngxxb818m7u1g2948kkkhdkrmbhspxfr6m27k7781uus5edukqzvpvpdusa4fqj4d41nh1d7uvzubddyb3rsb3zfka5bhuxwp9c","loading":"loading-2jyrwhha2khvu6w72ygw6ubrtbxwyuy86cwsrgx7au7bzap6znwb9uf7p9frsr8axcg84vau2c1c7jm9r42h8ehaeu8jpss4ak9459c","pulse":"pulse-2fbj83wczzk3sv3x1z42hdh1fhtmemwzkndcw1tzua9t225yc7t5dthwnhujbtza57nfumtyync42fwhnx2es3pc7gn3vq3ds6tuzya"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/UpcomingEvents/UpcomingEvents.module.scss
// module id = 1662
// module chunks = 0